<template>
  <div>
    <label><span class="font-semibold">{{ label }} </span><span class="text-red-500" v-if="required">*</span>
      <v-select :options="options" :value="value" v-on:input="setSelected" :disabled="disabled"
                :reduce="item => item[inputValue]" :label="inputLabel" :multiple="multiple"
                class="mt-1"
                :class="highlight ? 'style-chooser-select' : 'style-chooser'"
                :placeholder="placeholder" :loading="loading">
        <div slot="no-options">No se encontraron resultados</div>
      </v-select>
      <span class="flex items-center font-medium tracking-wide text-xs mt-1 ml-1"
            :class="state===true?'text-green-500':'text-red-500'"
            v-if="state!==null">{{ state === true ? validMessage : errorMessage }}
    </span>
    </label>
  </div>
</template>

<script>
export default {
  name: "SelectComponent",
  props: {
    value: null,
    highlight:  {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: []
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Seleccione una opción'
    },
    errorMessage: {
      type: String,
      default: 'No valido'
    },
    validMessage: {
      type: String,
      default: 'Valido'
    },
    state: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    inputLabel: {
      type: String,
      default: 'label'
    },
    inputValue: {
      type: String,
      default: 'code'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setSelected(value)
    {
      this.$emit('input', value)
    }
  }
}
</script>
<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: white;
  color: #394066;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}
.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}

.style-chooser-select .vs__search::placeholder,
.style-chooser-select .vs__dropdown-toggle,
.style-chooser-select .vs__dropdown-menu {
  background: white;
  color: #394066;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}
.style-chooser-select .vs__clear,
.style-chooser-select .vs__open-indicator {
  fill: #394066;
}
.style-chooser-select .vs__selected {
  width: auto;
  background: #e3efff;
  border: 1px solid #60a5fa;
}
.vs__search, .vs__search:focus {
  font-size: 13px;
}
</style>